export default __webpack_public_path__ + "static/media/suliac-room5-min.bd10df4f.jpg";